export { default } from './SharedBag';